import React, { useEffect, useState, useRef } from "react"

// used for videos with a playbutton that triggers play
const VideoWithPlayButton = ({ src, withControls, onMetaData, ...attrs }) => {
  const video = useRef()
  const [paused, setPaused] = useState( true )

  useEffect(() => {

    // load the video
    video.current.load()

    // handle play / pause events (if controls are active video can also play/pause from the control bar)
    video.current.onplay = () => {
      playVideo()
    }
    video.current.onpause = () => {
      pauseVideo()
    }
    
    // callback    
    video.current.onloadedmetadata = (e) => {
      if( onMetaData ) {
        onMetaData( e )
      }
    }

  }, [src])

  const playVideo = () => {
    setPaused( false )
    video.current.parentElement.classList.add( 'playing' )
    if( withControls ) {
      video.current.setAttribute( 'controls', 'controls' )        
    }
  }

  const pauseVideo = () => {
    // if a video is playing in ModalGallery.js when the modal is closed the video can be removed from the dom
    // before we do things,, so make sure the ref is still valid
    if( !video.current ) { return }       
    setPaused( true )
    video.current.parentElement.classList.remove( 'playing' )
    if( withControls ) {
      video.current.removeAttribute( 'controls' )        
    }
  }

  const togglePlay = ( e ) => {    
    if( paused ) {        
      video.current.play()      
    } else {
      video.current.pause()      
    }
    e.preventDefault()
  }

  return (
    <div className={ 'a-video-play-button'} onClick={ togglePlay } >
      <video { ...attrs } ref={ video } src={ src } />
    </div>
  )

  return (
    <div className={ 'a-video-play-button'} onClick={ togglePlay } >
      <video { ...attrs } ref={ video } >
        <source src={ src } type='video/webm;codecs="vp8, vorbis"'/>
        <source src={ src } type='video/mp4;codecs="avc1.42E01E, mp4a.40.2"'/>
      </video>
    </div>
  )

}

// used for autoplaying videos that loops (autoPlay, playsInline, loop) should be set as attributes
const Video = ({ src, ...attrs }) => {
  let video

  useEffect(() => {
    video.load()
    video.play()
  }, [src])

  return (
    <video { ...attrs } ref={ (ref) => {
      video = ref
    } } src={ src } preload="none"/>    
  )

  return (
    <video { ...attrs } ref={ (ref) => {
      video = ref
    } }>
      <source src={ src } type='video/webm;codecs="vp8, vorbis"'/>
      <source src={ src } type='video/mp4;codecs="avc1.42E01E, mp4a.40.2"'/>
    </video>
  )
}

export default ({ src, playButton=false, withControls=false, onMetaData=null, ...attrs }) => {

    if (!src) return null

    if( playButton ) return <VideoWithPlayButton src={ src } withControls={ withControls } onMetaData={ onMetaData } { ...attrs } />

    return <Video src={ src } { ...attrs } />
   
}